import { variables } from 'swag-client-common/styles/variables-js';
export const BUTTON_SHARED = {
  backgroundColor: variables.colorAccent,
  '&:hover': {
    backgroundColor: variables.colorAccent
  }
};